import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useDocumentDetails } from "@modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { decodeHTML } from "@utils/CommonUtils";
import { toInteger } from "lodash";
import { useEffect, useState } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { ContentWrapper } from "~/Components";
import { useNotification } from "~/Hooks/useNotification";
import { useQuery } from "~/Hooks/useQuery";
import { eramanCMSApi, post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useAirportDocumentDetails } from "./Airport.hooks";

export const AddEditStoreAirport = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const [records, setRecords] = useState<any[]>([]);

  const {
    data: editAirport,
    error,
    isLoading: drilldownLoading,
    isError,
    refetch: refetchCategories,
  } = useAirportDocumentDetails(query.get("editId") || "");

  const {
    data: editAirportById,
    isLoading: isLoadingProducts,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchCategories();
    }
  }, [query.get("editId"), query.get("id")]);

  const getRecords = () => {
    let url = `/api/airport/get-all`;
    eramanCMSApi
      .get(url)
      .then((res: any) => {
        if (res && res.data) {
          let envelopes = res.data;
          setRecords(envelopes);
        }
      })
      .catch(() => {
        setRecords([]);
      });
  };

  useEffect(() => {
    getRecords();
  }, []);

  const formConfig: FormConfig = {
    initialValues: {
      // field_airport_name_en: editAirportById
      //   ? decodeHTML(editAirportById.payload?.field_airport_name_en)
      //   : editAirport
      //     ? decodeHTML(editAirport?.field_airport_name_en)
      //     : "",
      field_airport_name_ms: editAirportById
        ? decodeHTML(editAirportById.payload?.field_airport_name_ms)
        : editAirport
          ? decodeHTML(editAirport?.field_airport_name_ms)
          : "",
      field_airport_name_zh: editAirportById
        ? decodeHTML(editAirportById.payload?.field_airport_name_zh)
        : editAirport
          ? decodeHTML(editAirport?.field_airport_name_zh)
          : "",

      name: editAirportById
        ? decodeHTML(editAirportById.payload.name)
        : editAirport
          ? decodeHTML(editAirport?.name)
          : "",

      field_airport_codes: editAirportById
        ? decodeHTML(editAirportById.payload.field_airport_codes)
        : editAirport
          ? decodeHTML(editAirport?.field_airport_codes)
          : "",
      field_airport_contact_name: editAirportById
        ? decodeHTML(editAirportById.payload.field_airport_contact_name)
        : editAirport
          ? decodeHTML(editAirport?.field_airport_contact_name)
          : "",
      field_airport_contact_number: editAirportById
        ? decodeHTML(editAirportById.payload.field_airport_contact_number)
        : editAirport
          ? decodeHTML(editAirport?.field_airport_contact_number)
          : "",
      field_airport_ranking: editAirportById
        ? decodeHTML(editAirportById.payload.field_airport_ranking)
        : editAirport
          ? decodeHTML(editAirport?.field_airport_ranking)
          : "",

      published: editAirportById
        ? decodeHTML(editAirportById.payload.published)
        : editAirport
          ? decodeHTML(editAirport?.published)
          : false,
    },
    // fields: fields.airport,
    fields: fields.airport.map((field: any) => {
      if (field.name === "field_airport_ranking") {
        return {
          ...field,
          validation: {
            required: `${field.label || field.name} is required`,
            validate: (value: string, formValues: FieldValues) => {
              if (!value) return true;
              const existingRecord = records.find((record: any) => {
                return (
                  toInteger(record[field.name]) === toInteger(value) &&
                  record.id !== (editAirport?.id || editAirportById?.payload?.id)
                );
              });
              return !existingRecord || `${field.label || field.name} already exists`;
            },
          },
        };
      }
      return field;
    }),
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);

    let imageKeys: any = ["field_common_image"];
    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field[0].originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else {
          data[key] = data[key][0].url;
        }
      } catch (error) {}
    }

    // // 🔹 Generate or preserve `name`
    // let finalName: string | undefined;
    // if (action === "CREATE" || method === "POST") {
    //   // take english name and generate slug
    //   finalName = data.field_airport_name_en?.toLowerCase().replace(/\s+/g, "-").trim();
    // } else if (action === "UPDATE" || method === "PATCH") {
    //   // preserve old name from DB
    //   finalName = editAirportById?.payload?.name || editAirport?.name;
    // }

    const payload = {
      action,
      method,
      module: "Store Location",
      subModule: "airport",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: editAirport?.id || editAirportById?.payload?.id }),
        ...data,
        // name: finalName, // 👈 handled dynamically
      },
      status,
    };

    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch(() => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <ContentWrapper
      title={`${query.get("id") || query.get("editId") ? "Edit" : "Add New"} Airport`}
      showBack
    >
      <DynamicForm
        isLoading={drilldownLoading || isLoadingProducts}
        config={formConfig}
        onSubmit={(data, buttonValue, reviewNotes) =>
          onSubmit(
            data,
            `${query.get("editId") ? `${eramanHost}/api/get-terminals-data/${editAirport?.id || editAirportById?.payload?.id}` : `${eramanHost}/api/create-terminals-data`}`,
            `${query.get("editId") ? "UPDATE" : "CREATE"}`,
            `${query.get("editId") ? "PATCH" : "POST"}`,
            buttonValue == "save" ? "DRAFT" : "PENDING",
            reviewNotes
          )
        }
      />
    </ContentWrapper>
  );
};
